import React, { useState } from 'react';
import { Popover, Divider } from '@bufferapp/components';
import { Text, Button } from '@bufferapp/ui';
import { ConfirmModal } from '~/shared-components';
import { useAppDispatch, useAppSelector } from '~/store';
import { selectCurrentProfile } from '~/profile-sidebar/selectors';
import { refreshSingleProfile } from '~/profiles/thunks/fetchSingleProfile';
import { emptyQueue } from '../thunks/emptyQueue';

const emptyQueueWrapperStyle = {
  display: 'flex',
  flexDirection: 'row',
  padding: '0.5rem 0px',
} as const;

const buttonWrapperStyle = {
  marginLeft: '0.5rem',
  minWidth: '175px',
  alignSelf: 'center',
  flex: '0.3 1 0%',
} as const;

const leftContentStyle = {
  flex: '1 1 0%',
} as const;

export const EmptyQueueAction = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector(selectCurrentProfile);
  const [isModalShowing, setModalShowing] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const showModal = () => setModalShowing(true);
  const hideModal = () => setModalShowing(false);

  // do not show Clean Queue action if there is no profile or user is not manager
  if (!profile?.isManager) return <></>;

  const onConfirmEmptyQueue = () => {
    const profileId = profile.id;
    setLoading(true);

    dispatch(emptyQueue({ profileId }))
      .then(() => dispatch(refreshSingleProfile({ profileId })))
      .then(() => {
        setLoading(false);
        hideModal();
      });
  };

  return (
    <div>
      <Divider />
      <div style={emptyQueueWrapperStyle}>
        {isModalShowing && (
          <Popover onOverlayClick={hideModal}>
            <ConfirmModal
              onConfirmClick={onConfirmEmptyQueue}
              onCloseModal={hideModal}
              profileService={profile.service}
              avatar={profile.avatarUrl}
              heading="Are you sure?"
              body={`All updates in your <span style="font-weight:bold">${profile.serviceUsername}</span> queue will be removed.`}
              btnText={isLoading ? 'Emptying Queue..' : 'Empty Queue'}
            />
          </Popover>
        )}
        <div style={leftContentStyle}>
          <Text type="h3">Empty Queue</Text>
          <Text type="p">
            Want a fresh start? Emptying your queue will remove all updates
            within your <strong>{profile.serviceUsername}</strong> queue.
          </Text>
        </div>
        <div style={buttonWrapperStyle}>
          <Button
            fullWidth
            type="primary"
            label="Empty Queue"
            data-testid="empty-queue-button"
            onClick={showModal}
          />
        </div>
      </div>
    </div>
  );
};
